// Alle Scripte des Themes, je Abschnitt ein Block, der nur läuft, wenn sein Element auf der Seite ist.
// Übernommen aus dem abgenommenen Astro-Entwurf (die-niachtn-frontend/src/sections/*.astro).
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  // ---------- Header: Scrollzustand, Menü, Logo-Flug ----------
  const kopf = $('[data-kopf]');
  if (kopf) {
    const menue = $('[data-menue]');
    const auf = $('[data-menue-auf]');
    const zu = $('[data-menue-zu]');
    const setzen = () => kopf.classList.toggle('kopf--gescrollt', scrollY > 40);
    addEventListener('scroll', setzen, { passive: true }); setzen();

    const zeige = (an) => {
      if (menue.hidden === !an) return;
      menue.hidden = !an; auf.setAttribute('aria-expanded', String(an));
      document.documentElement.style.overflow = an ? 'hidden' : '';
      (an ? zu : auf).focus();
    };
    auf.addEventListener('click', () => zeige(true));
    zu.addEventListener('click', () => zeige(false));
    $$('[data-menue-link]', menue).forEach((a) => a.addEventListener('click', () => zeige(false)));
    addEventListener('keydown', (e) => { if (e.key === 'Escape') zeige(false); });
    // Fenster breiter gezogen, während das Menü offen ist: sonst bliebe die Seite gesperrt.
    matchMedia('(min-width: 901px)').addEventListener('change', (e) => { if (e.matches) zeige(false); });

    // Aktiver Menüpunkt beim Scrollen (Startseite, Flo Auftrag #16): der Bereich, der die Linie bei 40 %
    // Fensterhöhe kreuzt, färbt seinen Punkt. „Shop“ zeigt auf /collections/all, gehört hier zu #shop.
    // Dazwischen (Hero, Intro, Showreel …) ist keiner aktiv. Unterseiten setzt header.liquid.
    const navLinks = $$('[data-nav-link]');
    const bereichVon = (a) => {
      const u = new URL(a.href);
      if (u.pathname === '/' && u.hash) return u.hash.slice(1);
      return u.pathname === '/collections/all' ? 'shop' : null;
    };
    const bereiche = [...new Set(navLinks.map(bereichVon))].map((id) => id && document.getElementById(id)).filter(Boolean);
    if (kopf.classList.contains('kopf--transparent') && bereiche.length) {
      const sichtbar = new Set();
      const markieren = () => {
        const aktiv = bereiche.find((b) => sichtbar.has(b))?.id;
        navLinks.forEach((a) => {
          if (aktiv && bereichVon(a) === aktiv) a.setAttribute('aria-current', 'location');
          else a.removeAttribute('aria-current');
        });
      };
      const beob = new IntersectionObserver((eintraege) => {
        eintraege.forEach((e) => (e.isIntersecting ? sichtbar.add(e.target) : sichtbar.delete(e.target)));
        markieren();
      }, { rootMargin: '-40% 0px -59% 0px' });
      bereiche.forEach((b) => beob.observe(b));
    }

    // Logo-Flug (nur Startseite): Header-Logo liegt über dem Platz im Hero und landet beim Scrollen
    // im Header. Ziel ist erreicht, wenn der Hero-Platz die Header-Position erreichen würde.
    const platz = $('[data-hero-logo]');
    const slot = $('[data-kopf-logo]');
    const flug = $('[data-logo-flug]');
    if (platz && kopf.classList.contains('kopf--transparent')) {
      let geplant = false;
      const fliegen = () => {
        geplant = false;
        const z = platz.getBoundingClientRect();
        const s = slot.getBoundingClientRect();
        const weg = z.top + scrollY - s.top;
        const p = weg > 0 ? Math.min(Math.max(scrollY / weg, 0), 1) : 1;
        const x = z.left + (s.left - z.left) * p;
        const y = z.top + (s.top - z.top) * p;
        const k = (z.width + (s.width - z.width) * p) / s.width;
        flug.style.transform = p === 1 ? '' : `translate(${x - s.left}px, ${y - s.top}px) scale(${k})`;
        flug.style.setProperty('--schatten', String(1 - p));
      };
      const planen = () => { if (!geplant) { geplant = true; requestAnimationFrame(fliegen); } };
      fliegen();
      kopf.classList.add('kopf--flug');
      document.documentElement.classList.add('logo-fliegt');
      addEventListener('scroll', planen, { passive: true });
      addEventListener('resize', planen);
    }
  }

  // ---------- Hero: Ton und Pause ----------
  const heroVideo = $('.hero__video');
  if (heroVideo) {
    const pause = $('[data-hero-pause]');
    const ton = $('[data-hero-ton]');
    const tonLabel = $('[data-hero-ton-label]');
    // Kein autoplay-Attribut: Start erst nach load, sonst konkurriert das Video mit Logo, Schriften und CSS.
    const starten = () => { if (!matchMedia('(prefers-reduced-motion: reduce)').matches) heroVideo.play().catch(() => {}); };
    if (document.readyState === 'complete') starten(); else addEventListener('load', starten, { once: true });
    const anzeigen = () => {
      pause.setAttribute('aria-pressed', String(heroVideo.paused));
      pause.setAttribute('aria-label', heroVideo.paused ? 'Video abspielen' : 'Video anhalten');
      ton?.setAttribute('aria-pressed', String(!heroVideo.muted));
      if (tonLabel) tonLabel.textContent = heroVideo.muted ? 'Ton an' : 'Ton aus';
    };
    pause.addEventListener('click', () => { heroVideo.paused ? heroVideo.play() : heroVideo.pause(); });
    ton?.addEventListener('click', () => {
      heroVideo.muted = !heroVideo.muted;
      if (!heroVideo.muted && heroVideo.paused) heroVideo.play();
    });
    ['play', 'pause', 'volumechange'].forEach((e) => heroVideo.addEventListener(e, anzeigen));
    anzeigen();
    // Hero aus dem Bild gescrollt: Ton aus, damit er nicht unter dem Showreel weiterläuft.
    new IntersectionObserver(([e]) => { if (!e.isIntersecting && !heroVideo.muted) heroVideo.muted = true; }, { threshold: 0.15 }).observe(heroVideo);
    $('.showreel__video')?.addEventListener('play', () => { heroVideo.muted = true; });
  }

  // ---------- Showreel: erst auf Klick ----------
  const showreelStart = $('[data-showreel-start]');
  showreelStart?.addEventListener('click', () => { showreelStart.remove(); $('.showreel__poster')?.remove(); $('.showreel__video').play(); });

  // ---------- Liveshows (Bandsintown-API) ----------
  // Feldnamen laut Antwort von rest.bandsintown.com/artists/id_…/events (geprüft 07.10.2026).
  const live = $('[data-live]');
  if (live) {
    const cfg = JSON.parse(live.dataset.live);
    const liste = $('[data-live-liste]', live);
    const vorlage = $('[data-live-vorlage]', live);
    const mehr = $('[data-live-mehr]', live);
    const WTAGE = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    const MONATE = ['Jän', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
    const LAENDER = { Austria: 'Österreich', Germany: 'Deutschland', Italy: 'Italien', Croatia: 'Kroatien', Switzerland: 'Schweiz', Slovenia: 'Slowenien' };

    // Zeit ist Ortszeit der Location, ohne Zone: nicht über Date in die Browserzone schieben.
    const zeile = (t) => {
      const [, j, m, d, hh, mm] = t.datetime.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
      const li = vorlage.content.cloneNode(true).firstElementChild;
      const q = (s) => $(s, li);
      q('.live__datum').setAttribute('datetime', t.datetime);
      q('.live__wtag').textContent = WTAGE[new Date(Date.UTC(+j, +m - 1, +d)).getUTCDay()];
      q('.live__tag').textContent = d;
      q('.live__monat').textContent = `${MONATE[+m - 1]} ${j.slice(2)}`;
      const land = t.venue.country === 'Austria' ? '' : `, ${LAENDER[t.venue.country] ?? t.venue.country}`;
      q('.live__stadt').textContent = t.venue.city.replace(/\b(Am|An|Im|Der|Dem)\b/g, (w) => w.toLowerCase()) + land;
      const titel = t.title?.trim(), venue = t.venue.name?.trim();
      q('.live__venue').textContent = titel && titel !== venue ? `${venue} · ${titel}` : venue;
      q('.live__zeit').textContent = `${hh}:${mm} Uhr`;
      const marke = q('.live__marke');
      if (t.sold_out) { marke.textContent = 'Ausverkauft'; marke.classList.add('live__marke--aus'); }
      else if (t.free) marke.textContent = 'Eintritt frei';
      const ticket = (t.offers || []).find((o) => o.url && o.status !== 'sold out');
      const a = q('.live__ticket');
      a.href = ticket?.url ?? t.url;
      a.textContent = ticket ? 'Tickets' : 'Infos';
      a.classList.add(ticket ? 'knopf--primaer' : 'knopf--sekundaer');
      return li;
    };
    const zeigen = (termine) => {
      liste.replaceChildren(...termine.map(zeile));
      $$('.live__zeile', liste).forEach((z, i) => { z.hidden = i >= cfg.anzahl; });
      mehr.hidden = termine.length <= cfg.anzahl;
      liste.setAttribute('aria-busy', 'false');
      if (!termine.length) $('[data-live-leer]', live).hidden = false;
    };
    mehr.addEventListener('click', () => { $$('.live__zeile', liste).forEach((z) => (z.hidden = false)); mehr.hidden = true; });
    fetch(`https://rest.bandsintown.com/artists/id_${cfg.id}/events?app_id=${encodeURIComponent(cfg.app)}&date=upcoming`)
      .then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then((d) => { if (!Array.isArray(d)) throw new Error('keine Liste'); zeigen(d); })
      .catch(() => { liste.replaceChildren(); liste.setAttribute('aria-busy', 'false'); $('[data-live-fehler]', live).hidden = false; });
  }

  // ---------- Externe Inhalte (YouTube, Spotify): erst nach Klick oder Einwilligung ----------
  const MEDIEN = 'niachtn-externe-inhalte'; // „Immer laden“ = Cookie-Kategorie Externe Medien (preferences)
  const externLaden = (el) => {
    const vorlage = $('template', el);
    if (!vorlage || el.dataset.geladen) return;
    const inhalt = vorlage.content.cloneNode(true);
    $('.extern__platzhalter', el)?.remove();
    el.append(inhalt);
    el.dataset.geladen = 'ja';
    el.dispatchEvent(new CustomEvent('extern:geladen', { bubbles: true }));
  };
  const alleExtern = () => $$('[data-extern]').forEach(externLaden);
  if (localStorage.getItem(MEDIEN) === 'ja') alleExtern();
  document.addEventListener('click', (e) => {
    const knopf = e.target.closest('[data-extern-laden]');
    if (!knopf) return;
    const el = knopf.closest('[data-extern]');
    if ($('[data-extern-immer]', el)?.checked) {
      localStorage.setItem(MEDIEN, 'ja');
      keks.erlaubeMedien();
      alleExtern();
    } else externLaden(el);
  });

  // ---------- Musikvideos: Slider und Player ----------
  const slider = $('[data-mv-slider]');
  if (slider) {
    const titel = $('[data-mv-titel]');
    const player = $('.mv__player');
    let aktuell = $('[data-mv-video]', slider)?.dataset.mvVideo;
    const url = (id, auto) => `https://www.youtube-nocookie.com/embed/${id}?rel=0${auto ? '&autoplay=1' : ''}`;
    $$('[data-mv-pfeil]').forEach((b) => b.addEventListener('click', () => slider.scrollBy({ left: Number(b.dataset.mvPfeil) * slider.clientWidth * 0.8, behavior: 'smooth' })));
    slider.addEventListener('click', (e) => {
      const karte = e.target.closest('[data-mv-video]');
      if (!karte || !player) return;
      aktuell = karte.dataset.mvVideo;
      $$('.ist-aktiv', slider).forEach((k) => k.classList.remove('ist-aktiv'));
      karte.classList.add('ist-aktiv');
      titel.textContent = karte.dataset.mvName;
      const iframe = $('[data-mv-iframe]', player);
      if (iframe) iframe.src = url(aktuell, true);
      else {
        // Noch nicht geladen: Vorschaubild tauschen, der Platzhalter bleibt.
        const poster = $('[data-mv-poster]', player);
        const neu = $('img', karte);
        if (poster && neu) { poster.src = neu.currentSrc || neu.src; poster.removeAttribute('srcset'); }
      }
      player.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    // Beim Laden über die Einwilligung das gewählte Video nehmen.
    player?.addEventListener('extern:geladen', () => {
      const iframe = $('[data-mv-iframe]', player);
      if (iframe && !iframe.src.includes(aktuell)) iframe.src = url(aktuell, true);
    });
  }

  // ---------- Galerie: Slideshow ----------
  // Wischen über Scroll-Snap; Pfeile, Punkte und Zähler folgen der Scrollposition.
  // Blättert alle 0,8 s weiter, solange sichtbar; jede Berührung stoppt das dauerhaft.
  const galerie = $('[data-galerie]');
  if (galerie) {
    const spur = $('[data-galerie-spur]', galerie);
    const folien = $$('.galerie__f', spur);
    const punkte = $$('[data-galerie-punkt]');
    const nr = $('[data-galerie-nr]');
    let index = 0;
    let takt = null;
    const gehe = (i) => {
      const n = (i + folien.length) % folien.length;
      spur.scrollTo({ left: n * spur.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    const stopp = () => { clearInterval(takt); takt = 'aus'; };
    spur.addEventListener('scroll', () => {
      const i = Math.round(spur.scrollLeft / spur.clientWidth);
      if (i === index || !folien[i]) return;
      index = i;
      punkte.forEach((p, k) => { p.classList.toggle('ist-aktiv', k === i); p.toggleAttribute('aria-current', k === i); });
      if (nr) nr.textContent = i + 1;
    }, { passive: true });
    $$('[data-galerie-pfeil]', galerie).forEach((b) => b.addEventListener('click', () => { stopp(); gehe(index + Number(b.dataset.galeriePfeil)); }));
    punkte.forEach((p) => p.addEventListener('click', () => { stopp(); gehe(Number(p.dataset.galeriePunkt)); }));
    ['pointerdown', 'wheel', 'touchstart', 'focusin'].forEach((t) => galerie.addEventListener(t, stopp, { passive: true }));
    galerie.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); stopp(); gehe(index + (e.key === 'ArrowRight' ? 1 : -1)); }
    });
    if (folien.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        if (takt === 'aus') return;
        clearInterval(takt);
        takt = e.isIntersecting ? setInterval(() => { if (!document.hidden) gehe(index + 1); }, 800) : null;
      }, { threshold: 0.5 }).observe(spur);
    }
  }

  // ---------- Kontaktformular: Datum und Ort nur beim ersten Anliegen (Booking) ----------
  const formular = $('#kontakt-formular');
  if (formular) {
    const anliegen = $('#k-anliegen', formular);
    const booking = $('[data-nur-booking]', formular);
    const zeigen = () => { booking.hidden = anliegen.selectedIndex !== 0; };
    anliegen.addEventListener('change', zeigen); zeigen();
    if ($('.formular__meldung, .formular__fehler', formular)) formular.scrollIntoView({ block: 'center' });
  }

  // ---------- Produkt: Variante aus den gewählten Optionen ----------
  const produkt = $('[data-produkt]');
  if (produkt) {
    const varianten = JSON.parse($('[data-varianten]', produkt).textContent);
    const feld = $('[data-variante]', produkt);
    const preis = $('[data-preis]', produkt);
    const kaufen = $('[data-kaufen]', produkt);
    const geld = new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' });
    // Nicht jede Kombination gibt es (Schnitt: Damen hat andere Größen als Kinder). Werte, die zu den Optionen
    // davor nicht passen, werden ausgeblendet; ist der gewählte darunter, springt die Wahl auf den ersten passenden.
    const felder = $$('.pd__option', produkt).map((f) => $$('[data-option]', f));
    const abgleichen = () => {
      felder.forEach((werte, i) => {
        const davor = felder.slice(0, i).map((w) => w.find((x) => x.checked)?.value);
        const passt = (wert) => varianten.some((x) => x.options[i] === wert && davor.every((d, j) => x.options[j] === d));
        werte.forEach((w) => { w.closest('label').hidden = !passt(w.value); });
        if (!werte.some((w) => w.checked && passt(w.value))) { const erster = werte.find((w) => passt(w.value)); if (erster) erster.checked = true; }
      });
    };
    const waehlen = () => {
      abgleichen();
      const gewaehlt = $$('[data-option]:checked', produkt).map((i) => i.value);
      const v = varianten.find((x) => x.options.every((o, i) => o === gewaehlt[i]));
      if (!v) { kaufen.disabled = true; kaufen.textContent = 'Nicht erhältlich'; return; }
      feld.value = v.id;
      preis.textContent = geld.format(v.price / 100);
      kaufen.disabled = !v.available;
      kaufen.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      const bild = v.featured_media && $(`[data-medium="${v.featured_media.id}"]`, produkt);
      if (bild && bild !== bild.parentNode.firstElementChild) bild.parentNode.prepend(bild);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };
    produkt.addEventListener('change', (e) => { if (e.target.matches('[data-option]')) waehlen(); });
    abgleichen();
  }

  // ---------- Warenkorb: +/− schickt das Formular ab ----------
  const korb = $('[data-korb]');
  korb?.addEventListener('click', (e) => {
    const b = e.target.closest('[data-menge]');
    if (!b) return;
    const input = $('input', b.parentElement);
    input.value = Math.max(0, Number(input.value) + Number(b.dataset.menge));
    korb.requestSubmit();
  });

  // ---------- Cookie-Banner (Shopify Customer Privacy API) ----------
  // Statistik = analytics, Marketing = marketing, Externe Medien = preferences.
  const keks = (() => {
    const el = $('[data-keks]');
    const wahl = el && $('[data-keks-wahl]', el);
    const feld = (k) => wahl.elements.namedItem(k);
    let api = null;
    const aktuell = () => {
      const c = api?.currentVisitorConsent?.() ?? {};
      return { medien: c.preferences === 'yes' || localStorage.getItem(MEDIEN) === 'ja', statistik: c.analytics === 'yes', marketing: c.marketing === 'yes' };
    };
    const zeigen = (einstellungen = false) => {
      if (!el) return;
      const w = aktuell();
      ['medien', 'statistik', 'marketing'].forEach((k) => { feld(k).checked = w[k]; });
      wahl.hidden = !einstellungen;
      $('[data-keks-speichern]', el).hidden = !einstellungen;
      $('[data-keks-mehr]', el).hidden = einstellungen;
      $('[data-keks-mehr]', el).setAttribute('aria-expanded', String(einstellungen));
      el.hidden = false;
    };
    const sichern = (w) => {
      const vorher = localStorage.getItem(MEDIEN) === 'ja';
      if (w.medien) localStorage.setItem(MEDIEN, 'ja'); else localStorage.removeItem(MEDIEN);
      api?.setTrackingConsent({ analytics: w.statistik, marketing: w.marketing, preferences: w.medien }, () => {});
      if (el) el.hidden = true;
      if (w.medien && !vorher) alleExtern();
      if (!w.medien && vorher) location.reload(); // schon geladene Player wieder entfernen
    };
    if (el) {
      $('[data-keks-alle]', el).addEventListener('click', () => sichern({ medien: true, statistik: true, marketing: true }));
      $('[data-keks-noetig]', el).addEventListener('click', () => sichern({ medien: false, statistik: false, marketing: false }));
      $('[data-keks-speichern]', el).addEventListener('click', () => sichern({ medien: feld('medien').checked, statistik: feld('statistik').checked, marketing: feld('marketing').checked }));
      $('[data-keks-mehr]', el).addEventListener('click', () => zeigen(true));
    }
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-keks-oeffnen]')) return;
      e.preventDefault(); zeigen(true);
    });
    const start = () => {
      api = window.Shopify?.customerPrivacy ?? null;
      if (!api) return;
      if (api.currentVisitorConsent?.().preferences === 'yes' && localStorage.getItem(MEDIEN) !== 'ja') { localStorage.setItem(MEDIEN, 'ja'); alleExtern(); }
      // shouldShowBanner() bleibt auch nach einer Wahl true (sale_of_data bleibt leer), darum zusätzlich:
      // nur zeigen, solange zu Statistik, Marketing oder Externe Medien noch nichts entschieden ist.
      const c = api.currentVisitorConsent?.() ?? {};
      const offen = ['analytics', 'marketing', 'preferences'].some((k) => !c[k]);
      if (api.shouldShowBanner() && offen) zeigen();
    };
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (fehler) => { if (!fehler) start(); });
    }
    // „Immer laden“ an einem Player zählt als Zustimmung zu Externe Medien, der Rest bleibt, wie er ist.
    return { erlaubeMedien: () => { const c = api?.currentVisitorConsent?.(); if (!c || ['analytics', 'marketing', 'preferences'].every((k) => !c[k])) return; const w = aktuell(); api.setTrackingConsent({ analytics: w.statistik, marketing: w.marketing, preferences: true }, () => {}); } };
  })();
})();
